export const getUser = state => state.users ? state.users.user : {};